import React from 'react'
import classNames from 'classnames'
import isNaN from 'lodash/isNaN'
import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'
import formatAmount from '@/modules/_helpers/formatAmount'

const useStyles = makeStyles((theme) => ({
  main: {
    textAlign: 'right',
  },
  positive: {
    color: theme.green,
  },
  negative: {
    color: theme.red,
  },
}))

export const BaseAmountCell = (props) => {
  const classes = useStyles()
  const { value, colorful = false } = props

  const getColorClass = () => {
    const parsedValue = parseFloat(value)

    if (!colorful || isNaN(parsedValue)) return {}

    return parsedValue > 0 ? classes.positive : classes.negative
  }
  const className = classNames(classes.main, getColorClass())

  return (
    <div className={className}>{formatAmount(value)}</div>
  )
}

BaseAmountCell.propTypes = {
  value: PropTypes.any,
  colorful: PropTypes.bool,
}

export default BaseAmountCell
